import { computed, defineComponent } from "@vue/composition-api";
import useUserPublicData from "@/hooks/useUserPublicData";
import { userPublicDataFieldsWithStoryInfo } from "@/lib/fieldsHelper";
import { ROLES } from "@/const";

export default defineComponent({
  name: "usersLiveController",
  setup(props, { emit }) {
    const { data, render, getFirstPage } = useUserPublicData(
      computed(() => ({ roles: [ROLES.CREATOR, ROLES.FULL_CREATOR], isLive: true, discoveryOnly: true })),
      undefined,
      userPublicDataFieldsWithStoryInfo()
    );
    getFirstPage().then(() => emit("load", data.value?.totalRecords));
    return render;
  },
});
